import {useTranslation} from "react-i18next";
import {createRef, useEffect, useState} from "react";
import {useOnClickOutside} from "usehooks-ts";
import GlobeIcon from "../../assets/v2/globe.png"
import {useSelector} from "react-redux";
import useLocalStorageState from "use-local-storage-state";
import useValetStore from "../../features/valet/hooks/useValetStore";

export default function LanguageSelector({}) {

    const [t, i18n] = useTranslation('common');
    const languages = ['fr', 'en'];
    const [opened, setOpened] = useState(false);
    const accountData = useSelector(state => state.account.accountData);
    const [accessToken, setAccessToken] = useLocalStorageState('accessToken');

    const ref: any = createRef();

    const {
        callPost,
    } = useValetStore();

    // useEffect(() => {
    //     console.log("LanguageSelector i18n.language=", i18n.language);
    // }, [i18n]);

    // NB Au démarage de l'appli, dans index.js, le systeme de localisation est déjà initialisé par rapport au localStorage
    // Si le language est différent dans le account, on le met à jour
    useEffect(() => {
        if (accountData != null) {
            changeLanguage(accountData.user.language);
        }
    }, [accountData]);

    useOnClickOutside(ref, () => {
        // console.log('outside click', opened)
        if (opened) {
            setOpened(false);
        }
    })

    const changeLanguageHandler = (language) => {
        // console.log("changeLanguageHandler accessToken=", accessToken);
        if (accessToken != null) {
            callPost('change_language', {'language': language}, (resultData => {
                changeLanguage(language);
            }));
        } else {
            changeLanguage(language);
        }
    }

    const changeLanguage = (language) => {
        if (languages.includes(language)) {
            localStorage.setItem('language', language);
            // console.log("changeLanguage language=", language);
            i18n.changeLanguage(language);
        } else {
            // Ignoré
        }
    }

    return <div className="flex flex-col cursor-pointer items-center" ref={ref}>
        <div className="flex items-center" onClick={(e) => setOpened(true)}>
            <div className="text-[14px] tracking-[2px] mr-1"><b>{i18n.language.toUpperCase()}</b></div>
            <div className="flex items-center mr-1">
                <img src={GlobeIcon} className="w-full h-full"/>
            </div>
        </div>
        {opened ?
            <div className="bg-black flex flex-col items-center z-[1400] text-[14px] p-2">
                {languages.map(lang => (
                    <a key={lang} href="#" onClick={() => {
                        changeLanguageHandler(lang);
                        setOpened(false);
                    }}
                       className="dropdown-item"><b>{lang.toUpperCase()}</b></a>
                ))}
            </div> : null}
    </div>
}